<template>
    <div class="actionBar">
        <div class="headerAction">
            <div v-if="actionHeaderIcon && actionheaderFunction" class="headerAction">
                <v-btn :color="actionHeaderColor" :icon="actionHeaderIcon" @click="actionheaderFunction" size="small" :style="{ color: actionHeaderTextColor }"></v-btn>
            </div>
            <h1>
                <span style="font-weight: 300;" class="mr-2">{{ firstElement }}</span> 
                <span class="mr-2" :class="{ 'text-accent': coloredSecond }">{{ secondElement }}</span>
            </h1>
        </div>
        <div v-if="actionIcon && actionRoute" class="rightAction">
            <v-btn :color="actionColor" :icon="actionIcon" :to="actionRoute"></v-btn>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'TopDeck',
        components: {  },
        props: {
            firstElement: String,
            secondElement: String,
            actionIcon: String,
            actionRoute: String,
            actionColor: String,
            actionHeaderIcon: String,
            actionheaderFunction: Function,
            actionHeaderColor: String,
            actionHeaderTextColor: String,
            coloredSecond: Boolean,
            filterPage: String 
        },
        data() {
            return {
                
            };
        },
        mounted() {
            
        },
        methods: {
            secondColor(){
                return this.coloredSecond ? 'username' : '';
            }
        }
    };
</script>

<style scoped>

    .headerAction {
        display: flex;
        align-items: center;
        gap: 1em;
    }

    .actionBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        text-overflow: ellipsis;
    }

    .rightAction {
        gap: 1em;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    h1 {
        font-family: "Open Runde", "Montserrat", "Segoe UI", sans-serif;
        font-weight: 400;
        font-size: 1.8rem;
        margin: 0;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        text-overflow: ellipsis;
    }

    /* --- MEDIA QUERIES --- */

    /* Petits écrans (<600px) */
    @media (max-width: 600px) {
        h1 {
            font-size: 1.4rem;
            text-align: center;
            width: 100%;
            justify-content: center;
        }

        .headerAction {
            justify-content: center;
            flex-direction: column;
            gap: 0.5em;
        }

        .actionBar {
            flex-direction: column;
            align-items: center;
            gap: 0.8em;
        }
    }

    /* Écrans moyens (600px–1024px) */
    @media (min-width: 601px) and (max-width: 1024px) {
        h1 {
            font-size: 1.6rem;
        }
    }

    /* Grands écrans (>1024px) */
    @media (min-width: 1025px) {
        h1 {
            font-size: 2rem;
        }
    }
</style>
